<template>
  <div>
    <v-row>
      <v-col md="7" cols="12">
        <v-card >
          <StatisticArticleTable></StatisticArticleTable>
        </v-card>
        <v-card cols="12">
         <StatisticArticleOverviewCard></StatisticArticleOverviewCard>
        </v-card>
      </v-col>
      <v-col>
        <v-card md="12">
          <StatisticArticleFeedCard></StatisticArticleFeedCard>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import StatisticArticleTable from "@/pages/admin/components/statistic/articles/table/statisticArticleTable"
import StatisticArticleOverviewCard from "@/pages/admin/components/statistic/articles/card/statisticArticleOverviewCard"
import StatisticArticleFeedCard from "@/pages/admin/components/statistic/articles/card/statisticArticleFeedCard"
export default {
  components:{
    StatisticArticleTable,
    StatisticArticleOverviewCard,
    StatisticArticleFeedCard
  }
}
</script>